import React from 'react'
import cx from 'classnames/bind'
import { IconContainer } from './Icon.styled'

export const names = [
  'pip',
  'sound_on',
  'sound_off',
  'share',
  'close',

  'check_on',
  'check_off',
  'checkbox_on',
  'checkbox_off',
  'add',
  'book_mark_on',
  'book_mark_off',

  'sns_kakao',
  'sns_facebook',
  'url_copy',
  'more',

  'new-tab',
  'warning',
  'close_circle',
  'close_small',
  'greater-than',
  'send_on',
  'send_off',

  'scroll_down',
  'scroll_up',
  'ten-minutes_minus',
  'play',
  'stop',
  'ten-minutes_plus',
  'tag_open',
  'tag_close',

  'mail',

  'call',
  'coupon',
  'heart_button',
  'heart_button_sp',
  'chat',
  'gift',
  'gift_sp',

  'preview',
  'heart',
  'arrow',
  'loading',
  'more',
  'heart_dark',
  // 'back',
  // 'comment',
  // 'delete',
  // 'edit',
  'bent_arrow',
  'close_silver',
  'close_middle_white',
  'close_black',
  'slide_close',
  'pin',
  'bell_active',
  'bell_disabled',
  'share_custom',
  'alarm_custom',
  'like_icon_0',
  'like_icon_1',
  'like_icon_2',
  'like_icon_3',
  'favorite_on',
  'favorite_off',
  'test',
  'powered_by',
  'reply',
  'reply_comment',
  'reply_edit',
  'reply_delete',
  'reply_cancel',

  'carot_left',
  'carot_right',
  'copy',
  'download',
  'plus',
  'purchase_auth',
] as const

/**
 * @description 확인완료
 */
type IconProps = {
  name?: typeof names[number]
  className?: string
  style?: React.CSSProperties
}
const Icon: React.FC<IconProps> = (props) => {
  const { name = names[0], style, className: rootClassName } = props

  const className = cx('root', name || '', 'fx-icon', rootClassName)

  return <IconContainer className={className} style={style}></IconContainer>
}

export default Icon
